export default "__VITE_ASSET__DpfZkccb__"